
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Modal } from "ant-design-vue";
import { useStore } from "vuex";
import { apiUpload } from "../../api/data";
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: Record<any, any>;
  percent?: number;
  url?: string;
  preview?: string;
  originFileObj?: any;
  thumbUrl?: string;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default defineComponent({
  components: {},
  props: {
    name: {
      type: String,
      default: "file",
    },
    number: {
      type: Number,
      default: 1,
    },
    item: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const gallery = reactive({
      fileList: [],
      loading: false,
      action: "",
      headers: { authorization: store.getters.assnUserToken },
      visible: false,
      src: "",
      preview: async (file: FileItem) => {
        if (!file.url && !file.preview) {
          file.preview = (await gallery.getBase64(
            file.originFileObj
          )) as string;
        }
        gallery.src = file.url || file.preview;
        gallery.visible = true;
      },
      cancel: () => {
        gallery.src = "";
        gallery.visible = false;
      },
      change: (info: FileInfo) => {
        gallery.loading = info.file.status === "uploading";
        if (info.file.status === "error") {
          Modal.error({
            centered: true,
            content: () => "上传失败",
          });
        } else if (info.file.status === "done") {
          const fileList: Record<any, any> = info.fileList;
          fileList.forEach((item: Record<any, any>) => {
            if (item.response !== undefined && item.response.code !== "0000") {
              item.status = "error";
              Modal.error({
                centered: true,
                content: () => item.response.text,
              });
            }
          });
          gallery.fileList = fileList;
        }
      },
      getBase64: (file: File) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      },
      getValues: () => {
        const values: Array<number> = [];
        gallery.fileList.forEach((item: Record<any, any>) => {
          if (typeof item.uid === "number") {
            values.push(item.uid);
          } else if (
            item.status === "done" &&
            item.response !== undefined &&
            item.response.code === "0000"
          ) {
            values.push(item.response.data[0].key);
          }
        });
        return values;
      },
    } as any);
    onMounted(async () => {
      gallery.fileList = props.item;
      gallery.action = await apiUpload();
    });
    return {
      ...toRefs(gallery),
    };
  },
});
